var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlecheGauche(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_49",
    "data-name": "Groupe 49",
    transform: "translate(-15 -572)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 80,
    height: 80,
    transform: "translate(15 572)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_45",
    "data-name": "Groupe 45",
    transform: "translate(24 583)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_736",
    "data-name": "Rectangle 736",
    width: 5.779,
    height: 5.779,
    transform: "translate(0 23.115)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_737",
    "data-name": "Rectangle 737",
    width: 5.779,
    height: 5.779,
    transform: "translate(0 28.893)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_738",
    "data-name": "Rectangle 738",
    width: 5.779,
    height: 5.779,
    transform: "translate(5.778 17.336)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_739",
    "data-name": "Rectangle 739",
    width: 5.779,
    height: 5.779,
    transform: "translate(5.778 23.115)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_740",
    "data-name": "Rectangle 740",
    width: 5.779,
    height: 5.779,
    transform: "translate(5.778 28.894)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_741",
    "data-name": "Rectangle 741",
    width: 5.779,
    height: 5.779,
    transform: "translate(5.778 34.672)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_742",
    "data-name": "Rectangle 742",
    width: 5.779,
    height: 5.779,
    transform: "translate(11.442 11.557)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_743",
    "data-name": "Rectangle 743",
    width: 5.779,
    height: 5.779,
    transform: "translate(11.442 17.336)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_744",
    "data-name": "Rectangle 744",
    width: 5.779,
    height: 5.779,
    transform: "translate(11.442 23.115)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_745",
    "data-name": "Rectangle 745",
    width: 5.779,
    height: 5.779,
    transform: "translate(11.442 28.894)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_746",
    "data-name": "Rectangle 746",
    width: 5.779,
    height: 5.779,
    transform: "translate(11.442 34.672)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_747",
    "data-name": "Rectangle 747",
    width: 5.779,
    height: 5.779,
    transform: "translate(11.442 40.451)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_748",
    "data-name": "Rectangle 748",
    width: 5.779,
    height: 5.779,
    transform: "translate(17.164 5.779)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_749",
    "data-name": "Rectangle 749",
    width: 5.779,
    height: 5.779,
    transform: "translate(17.164 11.557)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_750",
    "data-name": "Rectangle 750",
    width: 5.779,
    height: 5.779,
    transform: "translate(17.164 17.336)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_751",
    "data-name": "Rectangle 751",
    width: 5.779,
    height: 5.779,
    transform: "translate(17.164 23.115)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_752",
    "data-name": "Rectangle 752",
    width: 5.779,
    height: 5.779,
    transform: "translate(17.164 28.894)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_753",
    "data-name": "Rectangle 753",
    width: 5.779,
    height: 5.779,
    transform: "translate(17.164 34.672)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_754",
    "data-name": "Rectangle 754",
    width: 5.779,
    height: 5.779,
    transform: "translate(17.164 40.451)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_755",
    "data-name": "Rectangle 755",
    width: 5.779,
    height: 5.779,
    transform: "translate(17.164 46.23)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_756",
    "data-name": "Rectangle 756",
    width: 5.779,
    height: 5.779,
    transform: "translate(22.885)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_757",
    "data-name": "Rectangle 757",
    width: 5.779,
    height: 5.779,
    transform: "translate(22.885 5.779)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_758",
    "data-name": "Rectangle 758",
    width: 5.779,
    height: 5.779,
    transform: "translate(22.885 11.557)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_759",
    "data-name": "Rectangle 759",
    width: 5.779,
    height: 5.779,
    transform: "translate(22.885 17.336)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_760",
    "data-name": "Rectangle 760",
    width: 5.779,
    height: 5.779,
    transform: "translate(22.885 23.115)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_761",
    "data-name": "Rectangle 761",
    width: 5.779,
    height: 5.779,
    transform: "translate(22.885 28.894)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_762",
    "data-name": "Rectangle 762",
    width: 5.779,
    height: 5.779,
    transform: "translate(22.885 34.672)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_763",
    "data-name": "Rectangle 763",
    width: 5.779,
    height: 5.779,
    transform: "translate(22.885 40.451)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_764",
    "data-name": "Rectangle 764",
    width: 5.779,
    height: 5.779,
    transform: "translate(22.885 46.23)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_765",
    "data-name": "Rectangle 765",
    width: 5.779,
    height: 5.779,
    transform: "translate(22.885 52.009)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_766",
    "data-name": "Rectangle 766",
    width: 5.779,
    height: 5.779,
    transform: "translate(28.607)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_767",
    "data-name": "Rectangle 767",
    width: 5.779,
    height: 5.779,
    transform: "translate(28.607 5.779)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_768",
    "data-name": "Rectangle 768",
    width: 5.779,
    height: 5.779,
    transform: "translate(28.607 11.557)",
    fill: "#ffdb80"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_769",
    "data-name": "Rectangle 769",
    width: 5.779,
    height: 5.779,
    transform: "translate(28.607 17.336)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_770",
    "data-name": "Rectangle 770",
    width: 5.779,
    height: 5.779,
    transform: "translate(28.607 23.115)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_771",
    "data-name": "Rectangle 771",
    width: 5.779,
    height: 5.779,
    transform: "translate(28.607 28.894)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_772",
    "data-name": "Rectangle 772",
    width: 5.779,
    height: 5.779,
    transform: "translate(28.607 34.672)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_773",
    "data-name": "Rectangle 773",
    width: 5.779,
    height: 5.779,
    transform: "translate(28.607 40.451)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_774",
    "data-name": "Rectangle 774",
    width: 5.779,
    height: 5.779,
    transform: "translate(28.607 46.23)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_775",
    "data-name": "Rectangle 775",
    width: 5.779,
    height: 5.779,
    transform: "translate(28.607 52.009)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_776",
    "data-name": "Rectangle 776",
    width: 5.779,
    height: 5.779,
    transform: "translate(34.328 5.779)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_777",
    "data-name": "Rectangle 777",
    width: 5.779,
    height: 5.779,
    transform: "translate(34.328 11.557)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_778",
    "data-name": "Rectangle 778",
    width: 5.779,
    height: 5.779,
    transform: "translate(34.328 17.336)",
    fill: "#ffdb80"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_779",
    "data-name": "Rectangle 779",
    width: 5.779,
    height: 5.779,
    transform: "translate(34.328 23.115)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_780",
    "data-name": "Rectangle 780",
    width: 5.779,
    height: 5.779,
    transform: "translate(34.328 28.894)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_781",
    "data-name": "Rectangle 781",
    width: 5.779,
    height: 5.779,
    transform: "translate(34.328 34.672)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_782",
    "data-name": "Rectangle 782",
    width: 5.779,
    height: 5.779,
    transform: "translate(34.328 40.451)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_783",
    "data-name": "Rectangle 783",
    width: 5.779,
    height: 5.779,
    transform: "translate(34.328 46.23)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_784",
    "data-name": "Rectangle 784",
    width: 5.779,
    height: 5.779,
    transform: "translate(40.049 17.336)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_785",
    "data-name": "Rectangle 785",
    width: 5.779,
    height: 5.779,
    transform: "translate(40.049 23.115)",
    fill: "#ffdb80"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_786",
    "data-name": "Rectangle 786",
    width: 5.779,
    height: 5.779,
    transform: "translate(40.049 28.894)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_787",
    "data-name": "Rectangle 787",
    width: 5.779,
    height: 5.779,
    transform: "translate(40.049 34.672)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_788",
    "data-name": "Rectangle 788",
    width: 5.779,
    height: 5.779,
    transform: "translate(45.77 17.336)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_789",
    "data-name": "Rectangle 789",
    width: 5.779,
    height: 5.779,
    transform: "translate(45.77 23.115)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_790",
    "data-name": "Rectangle 790",
    width: 5.779,
    height: 5.779,
    transform: "translate(45.77 28.894)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_791",
    "data-name": "Rectangle 791",
    width: 5.779,
    height: 5.779,
    transform: "translate(45.77 34.672)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_792",
    "data-name": "Rectangle 792",
    width: 5.779,
    height: 5.779,
    transform: "translate(51.434 17.336)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_793",
    "data-name": "Rectangle 793",
    width: 5.779,
    height: 5.779,
    transform: "translate(51.434 23.115)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_794",
    "data-name": "Rectangle 794",
    width: 5.779,
    height: 5.779,
    transform: "translate(51.434 28.894)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_795",
    "data-name": "Rectangle 795",
    width: 5.779,
    height: 5.779,
    transform: "translate(57.213 23.115)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_796",
    "data-name": "Rectangle 796",
    width: 5.779,
    height: 5.779,
    transform: "translate(57.213 28.894)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_797",
    "data-name": "Rectangle 797",
    width: 5.779,
    height: 5.779,
    transform: "translate(51.434 34.672)",
    fill: "#3d3d3d"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlecheGauche);
export default __webpack_public_path__ + "static/media/fleche_gauche.2b1b3edbb934262e9739584581f28d9d.svg";
export { ForwardRef as ReactComponent };